import { QueryKeys } from '@/constants/query-keys';
import { AnalyticsBaseType } from '@/types/analytics';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useAnalyticsLog = (): ReturnType<typeof useMutation<void, unknown, Record<string, AnalyticsBaseType>>> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => {
      const currentQueue = queryClient.getQueryData<Record<string, AnalyticsBaseType>[]>(QueryKeys.global.analyticsLog) || [];
      if (currentQueue.length >= 100) {
        currentQueue.pop();
      }

      const newLogs = [data, ...currentQueue];
      queryClient.setQueryData<Record<string, AnalyticsBaseType>[]>(QueryKeys.global.analyticsLog, newLogs);

      return Promise.resolve();
    },
  });
};
